'use strict';

angular.module('mean.projects').controller('ReportController', ['$scope', 'MeanUser', 'Global', '$filter', '$q', 'toaster', 'Bids', 'ngDialog', 'taskTotalsService', 'tradeCodeService', 'foremanPhaseService',
  function($scope, MeanUser, Global, $filter, $q, toaster,  Bids, ngDialog, taskTotalsService, tradeCodeService, foremanPhaseService) {
    $scope.global = Global;

    $scope.user = MeanUser.user;

    $scope.selectedBid = {};

    $scope.ConvertReportToCSV = function(objArray, bidNote) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        console.log($scope.selectedItem);
        var str = $scope.selectedItem.name + ',Phase,';
        if(array.rows.length > 0) {
            _.each(array.rows[0].columns, function(col) {
                str += col.phase + ',';
            });
        }
        str += '\r\n';

        str += array.column_type + ',Lot,';
        if(array.rows.length > 0) {
            _.each(array.rows[0].columns, function(col) {
                str += col.lot + ',';
            });
        }
        str += '\r\n';

        str += ',Plan,';
        if(array.rows.length > 0) {
            _.each(array.rows[0].columns, function(col) {
                str += col.plan + ',';
            });
        }
        str += 'Total' + '\r\n';

        if(bidNote) {
            str += array.row_type + ',Note' + '\r\n';
        } else {
            str += array.row_type + '\r\n';
        }

        _.each(array.rows, function(row, ii) {
            str += row.name;
            if(bidNote && ii < array.rows.length-1) {
                str += ',' + row.note + ',';
            } else {
                str += ',,';
            }

            var row_total = 0;
            _.each(row.columns, function(col) {
                str += col.value + ',';
                row_total += col.value;
            });
            str += row_total + '\r\n';
        });

        return str;
    };

    $scope.ConvertBidReportToCSV = function(objArray, bidNote) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        
        var str = $scope.selectedBid.bid_name + ',Plan,';
        if(array.rows.length > 0) {
            _.each(array.rows[0].columns, function(col) {
                str += col.plan + ',';
            });
        }
        str += 'Total' + '\r\n';

        if(bidNote) {
            str += array.row_type + ',Note' + '\r\n';
        } else {
            str += array.row_type + '\r\n';
        }

        _.each(array.rows, function(row, ii) {
            str += row.name;
            if(bidNote && ii < array.rows.length-1) {
                str += ',' + row.note + ',';
            } else {
                str += ',,';
            }

            var row_total = 0;
            _.each(row.columns, function(col) {
                str += col.value + ',';
                row_total += col.value;
            });
            str += row_total + '\r\n';
        });

        return str;
    };

    $scope.exportReportFile = function(objArray, bidNote) {
        var dataUrl = '';
        if($scope.project_side)
            dataUrl = 'data:text/csv;utf-8,' + encodeURI($scope.ConvertReportToCSV(objArray, bidNote));
        else
            dataUrl = 'data:text/csv;utf-8,' + encodeURI($scope.ConvertBidReportToCSV(objArray, bidNote));
        var link = document.createElement('a');
        angular.element(link)
            .attr('href', dataUrl)
            .attr('download', 'report.csv') // Pretty much only works in chrome
        link.click();
    };

    $scope.buildReportData = function(bids) {
        var selected_bid = {};
        var bidNote = false;

        _.each(bids[0].bidding_trades, function(trade) {
            var bid_revs = [];
            _.each(trade.revisions, function(rev, idx) {
                bid_revs.push(idx+1);
            });

            bid_revs.push(bid_revs.length+1);

            trade.bid_list = taskTotalsService.mergeBidAndTaskList(
                $scope.plans, 
                tradeCodeService.getCode($scope.user.trade[0]), 
                trade,
                bid_revs);


            taskTotalsService.getCalculations(
                trade.bid_list, 
                trade.costs);

            selected_bid = trade;
        });

        var report_lots = [];
        var report_plans = [];

        var lots = $filter('orderBy')($scope.ordered_lots, ['phase', 'number']);
        _.each(lots, function(lotSelect) {
            if($scope.report_options.selected_lot[0] === 'All' &&
                $scope.report_options.selected_phase[0] === 'All') {
                report_lots.push({
                    'phase': lotSelect.phase,
                    'lot': lotSelect.number,
                    'plan': lotSelect.plan,
                    'revision': lotSelect.revision
                });
                if(report_plans.indexOf(lotSelect.plan) === -1)
                  report_plans.push(lotSelect.plan);
            } else if($scope.report_options.selected_lot[0] === 'All' &&
                $scope.report_options.selected_phase.indexOf(lotSelect.phase) !== -1) {
                report_lots.push({
                    'phase': lotSelect.phase,
                    'lot': lotSelect.number,
                    'plan': lotSelect.plan,
                    'revision': lotSelect.revision
                });
                if(report_plans.indexOf(lotSelect.plan) === -1)
                  report_plans.push(lotSelect.plan);
            } else if($scope.report_options.selected_lot.indexOf(lotSelect.number) !== -1) {
                report_lots.push({
                    'phase': lotSelect.phase,
                    'lot': lotSelect.number,
                    'plan': lotSelect.plan,
                    'revision': lotSelect.revision
                });
                if(report_plans.indexOf(lotSelect.plan) === -1)
                  report_plans.push(lotSelect.plan);
            }
        });

        var planData = [];

        //materials that are not combined can cause problems with the
        //report data by adding duplicate columns.  per_entry is used
        //to make sure we just adjust value totals instead of dup columns.
        var per_entry = false;

        //build data for each plan involved in the report
        _.each(report_plans, function(planReport) {
            var datas = $filter('filter')(selected_bid.bid_list, {'plan': planReport}, true);

            if($scope.report_options.selected_row === "General Tasks") {
                if($scope.report_options.selected_column === "Bid Labor Hours") {
                    var bid_labor_hours = 0;
                    _.each(datas, function(item) {
                        bid_labor_hours += item.total_hours_allowed;
                        planData.push({
                            'plan': planReport,
                            'name': item.trade + item.task + ' - ' + item.name,                                    
                            'task': item.trade + item.task,
                            'value': item.total_hours_allowed,
                            'revision': item.revision
                        });
                    });
                    planData.row_total = bid_labor_hours;
                } else if($scope.report_options.selected_column === "Bid Direct Labor Cost") {
                    var total_current_net_pay = 0;
                    _.each(datas, function(item) {
                        total_current_net_pay += item.total_current_net_pay;
                        planData.push({
                            'plan': planReport,
                            'name': item.trade + item.task + ' - ' + item.name,
                            'task': item.trade + item.task,
                            'value': item.total_current_net_pay,
                            'revision': item.revision
                        });
                    });
                    planData.row_total = total_current_net_pay;
                } else if($scope.report_options.selected_column === "Bid Total Material Cost") {
                    var total_materials = 0;
                    _.each(datas, function(item) {
                        total_materials += item.total_materials;
                        planData.push({
                            'plan': planReport,
                            'name': item.trade + item.task + ' - ' + item.name,
                            'task': item.trade + item.task,
                            'value': item.total_materials,
                            'revision': item.revision
                        });
                    });
                    planData.row_total = total_materials;
                } else if($scope.report_options.selected_column === "Bid Total Equipment Cost") {
                    var total_equipment = 0;
                    _.each(datas, function(item) {
                        total_equipment += item.total_equipment;
                        planData.push({
                            'plan': planReport,
                            'name': item.trade + item.task + ' - ' + item.name,
                            'task': item.trade + item.task,
                            'value': item.total_equipment,
                            'revision': item.revision
                        });
                    });
                    planData.row_total = total_equipment;
                }
            } else if($scope.report_options.selected_row === "Subtasks") {
                bidNote = true;
                if($scope.report_options.selected_column === "Bid Labor Hours") {
                    var bid_labor_hours = 0;
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            bid_labor_hours += data.hours_allowed;
                            planData.push({
                                'plan': planReport,
                                'name': data.trade + data.task + ' - ' + data.name,
                                'note': data.note,
                                'task': data.trade + data.task,
                                'value': data.hours_allowed,
                                'revision': item.revision
                            });
                        });
                    });
                    planData.row_total = bid_labor_hours;
                } else if($scope.report_options.selected_column === "Bid Direct Labor Cost") {
                    var total_labor = 0;
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            total_labor += data.current_net_pay;
                            planData.push({
                                'plan': planReport,
                                'name': data.trade + data.task + ' - ' + data.name,
                                'note': data.note,
                                'task': data.trade + data.task,
                                'value': data.current_net_pay,
                                'revision': item.revision
                            });
                        });
                    });
                    planData.row_total = total_labor;
                } else if($scope.report_options.selected_column === "Bid Total Material Cost") {
                    var material_total = 0;
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            material_total += data.material_total;
                            planData.push({
                                'plan': planReport,
                                'name': data.trade + data.task + ' - ' + data.name,
                                'note': data.note,
                                'task': data.trade + data.task,
                                'value': data.material_total,
                                'revision': item.revision
                            });
                        });
                    });
                    planData.row_total = material_total;
                } else if($scope.report_options.selected_column === "Bid Total Equipment Cost") {
                    var equipment_total = 0;
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            equipment_total += data.equipment_total;
                            planData.push({
                                'plan': planReport,
                                'name': data.trade + data.task + ' - ' + data.name,
                                'note': data.note,
                                'task': data.trade + data.task,
                                'value': data.equipment_total,
                                'revision': item.revision
                            });
                        });
                    });
                    planData.row_total = equipment_total;
                }
            } else if($scope.report_options.selected_row === "Materials") {
                bidNote = true;
                if($scope.report_options.selected_column === "Bid Quantity (combined)") {
                    var quantity_total = 0;
                    var materials = [];
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.materials, function(material) {
                                material.bid_quantity = material.quantity;
                                material.note = (material.note)?material.note:'';
                                material.revision = item.revision;
                                materials.push(material)
                            })
                        });
                    });

                    var new_consolidated_list = 
                        foremanPhaseService.combineSimilarNoteItems(materials);
                    _.each(new_consolidated_list, function(data) {
                        quantity_total += data.quantity;

                        planData.push({
                            'plan': planReport,
                            'name': data.name,
                            'note': data.note,
                            'color_code': data.color_code,
                            'value': data.quantity,
                            'revision': data.revision
                        });
                    });
                    planData.row_total = quantity_total;
                } else if($scope.report_options.selected_column === "Bid Quantity (per entry)") {
                    per_entry = true;
                    var quantity_total = 0;
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.materials, function(material) {
                                quantity_total += material.total;
                                material.note = (material.note)?material.note:'';

                                planData.push({
                                    'plan': planReport,
                                    'name': material.name,
                                    'note': material.note,
                                    'color_code': material.color_code,
                                    'value': material.quantity,
                                    'revision': item.revision
                                });
                            })
                        });
                    });
                    planData.row_total = quantity_total;
                } else if($scope.report_options.selected_column === "Bid Cost (combined)") {
                    var total = 0;
                    var materials = [];
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.materials, function(material) {
                                material.bid_quantity = material.quantity;
                                material.note = (material.note)?material.note:'';
                                material.revision = item.revision;
                                materials.push(material)
                            })
                        });
                    });
                    var new_consolidated_list = 
                        foremanPhaseService.combineSimilarNoteItems(materials);
                    
                    _.each(new_consolidated_list, function(data) {
                        total += data.total;

                        planData.push({
                            'plan': planReport,
                            'name': data.name,
                            'note': data.note,
                            'color_code': data.color_code,
                            'value': data.total,
                            'revision': data.revision
                        });
                    });
                    planData.row_total = total;
                } else if($scope.report_options.selected_column === "Bid Cost (per entry)") {
                    per_entry = true;
                    var mat_total = 0;
                    var tax = 0;
                    if($scope.project_side) {
                        tax = $scope.selectedItem.trades[0].company_factors.sales_tax;
                    } else {
                        tax = $scope.my_bid.costs.equipment_tax;
                    }
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.materials, function(material) {
                                var sales_tax = material.materials_subtotal * tax;
                                material.total = material.materials_subtotal + sales_tax +
                                    material.materials_dev_subtotal;
                                mat_total += material.total;
                                material.note = (material.note)?material.note:'';

                                planData.push({
                                    'plan': planReport,
                                    'name': material.name,
                                    'note': material.note,
                                    'color_code': material.color_code,
                                    'value': material.total,
                                    'revision': item.revision
                                });
                            })
                        });
                    });
                    planData.row_total = mat_total;
                }
            } else if($scope.report_options.selected_row === "Equipment") {
                bidNote = true;
                if($scope.report_options.selected_column === "Bid Quantity (combined)") {
                    var quantity_total = 0;
                    var equipment = [];
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.equipment, function(item) {
                                item.bid_quantity = item.quantity;
                                item.note = (item.note)?item.note:'';
                                equipment.push(item)
                            })
                        });
                    });

                    equipment = foremanPhaseService.combineSimilarItems(equipment);

                    var consolidated_list = [];

                    if($scope.project_side) {
                        consolidated_list = foremanPhaseService.consolidateEquipmentOnForemanNotes(
                            equipment, $scope.selectedItem.trades[0].company_factors.equipment_tax);
                    } else {
                        consolidated_list = foremanPhaseService.consolidateEquipmentOnForemanNotes(
                            equipment, $scope.my_bid.costs.equipment_tax);
                    }

                    //materials = foremanPhaseService.combineSimilarItems(materials);
                    _.each(consolidated_list, function(data) {
                        quantity_total += data.quantity;

                        planData.push({
                            'plan': planReport,
                            'name': data.name,
                            'note': data.note,
                            'value': data.quantity,
                            'revision': item.revision
                        });
                    });
                    planData.row_total = quantity_total;
                } else if($scope.report_options.selected_column === "Bid Quantity (per entry)") {
                    per_entry = true;
                    var quantity_total = 0;
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.equipment, function(equip) {
                                quantity_total += equip.total;
                                equip.note = (equip.note)?equip.note:'';

                                planData.push({
                                    'plan': planReport,
                                    'name': equip.name,
                                    'note': equip.note,
                                    'value': equip.quantity,
                                    'revision': item.revision
                                });
                            })
                        });
                    });
                    planData.row_total = quantity_total;
                } else if($scope.report_options.selected_column === "Bid Cost (combined)") {
                    var total = 0;
                    var equipment = [];
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.equipment, function(equip) {
                                equip.bid_quantity = equip.quantity;
                                equip.note = (equip.note)?equip.note:'';
                                equipment.push(equip)
                            })
                        });
                    });
                    var new_consolidated_list = 
                        foremanPhaseService.combineSimilarNoteItems(equipment);
                    
                    _.each(new_consolidated_list, function(data) {
                        total += data.total;

                        planData.push({
                            'plan': planReport,
                            'name': data.name,
                            'note': data.note,
                            'value': data.total,
                            'revision': item.revision
                        });
                    });
                    planData.row_total = total;
                } else if($scope.report_options.selected_column === "Bid Cost (per entry)") {
                    per_entry = true;
                    var equip_total = 0;
                    var tax = 0;
                    if($scope.project_side) {
                        tax = $scope.selectedItem.trades[0].company_factors.equipment_tax;
                    } else {
                        tax = $scope.my_bid.costs.equipment_tax;
                    }
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.equipment, function(equip) {
                                var sales_tax = equip.equipment_subtotal * tax;
                                equip.total = equip.equipment_subtotal + sales_tax +
                                    equip.equipment_dev_subtotal;
                                equip_total += equip.total;
                                equip.note = (equip.note)?equip.note:'';

                                planData.push({
                                    'plan': planReport,
                                    'name': equip.name,
                                    'note': equip.note,
                                    'value': equip.total,
                                    'revision': item.revision
                                });
                            })
                        });
                    });
                    planData.row_total = equip_total;
                }
            }
        });

        var report = {
            'row_type': $scope.report_options.selected_row,
            'column_type': $scope.report_options.selected_column,
            'rows': []
        }

        var column_total = 0;
        var first = true;
        //build data table based on lots being used
        _.each(report_lots, function(lot, ii) {
            var itemDatas = $filter('filter')(planData, {'plan': lot.plan, 'revision': lot.revision}, true);
            
            if(per_entry) {
                if(!report.rows.columns) report.rows.columns = [];

                _.each(itemDatas, function(data, idx) {
                    //if(lot.revision === data.revision) {
                        if(!report.rows.columns) report.rows.columns = [];

                        if(first) {
                            report.rows.push({
                                name: data.name,
                                note: data.note,
                                columns: [{
                                    'lot': lot.lot,
                                    'phase': lot.phase,
                                    'plan': lot.plan,
                                    'value': data.value
                                }]
                            })
                        } else {
                            report.rows[idx].columns.push({
                                'lot': lot.lot,
                                'phase': lot.phase,
                                'plan': lot.plan,
                                'value': data.value
                            })
                        }

                        column_total += data.value;
                        if(idx === itemDatas.length-1) {
                            var col_total = $filter('filter')(report.rows, {'name': 'Totals'}, true);

                            if(col_total.length === 0) {
                                report.rows.push({
                                    'name': 'Totals',
                                    'columns': [{
                                        'value': column_total
                                    }]
                                });
                            } else if(col_total.length === 1) {
                                col_total[0].columns.push({
                                    'value': column_total
                                })
                            }

                            column_total = 0;
                        }
                    //}
                });

                first = false;
            } else {
                _.each(itemDatas, function(data, idx) {
                    //if(lot.revision === data.revision) {
                        var inlist = [];
                        if(bidNote) {
                            inlist = $filter('filter')(report.rows, {
                                'name': data.name, 'note': data.note}, true);
                        } else {
                            inlist = $filter('filter')(report.rows, {'name': data.name}, true);
                        }

                        if(inlist.length === 0) {
                            if(!report.rows.columns) report.rows.columns = [];

                            report.rows.push({
                                name: data.name,
                                note: data.note,
                                columns: [{
                                    'lot': lot.lot,
                                    'phase': lot.phase,
                                    'plan': lot.plan,
                                    'value': data.value
                                }]
                            })
                        } else if(inlist.length === 1) {
                            inlist[0].columns.push({
                                'lot': lot.lot,
                                'phase': lot.phase,
                                'plan': lot.plan,
                                'value': data.value
                            })
                        } else {
                            toaster.pop('Report Error', 'Something is wrong');
                            return;
                        }

                        column_total += data.value;
                        if(idx === itemDatas.length-1) {
                            var col_total = $filter('filter')(report.rows, {'name': 'Totals'}, true);

                            if(col_total.length === 0) {
                                report.rows.push({
                                    'name': 'Totals',
                                    'columns': [{
                                        'value': column_total
                                    }]
                                });
                            } else if(col_total.length === 1) {
                                col_total[0].columns.push({
                                    'value': column_total
                                })
                            }

                            column_total = 0;
                        }
                    //}
                })
            }
        });

        console.log(report);
        $scope.exportReportFile(report, bidNote);
    };

    $scope.buildBidReportData = function(bids, plans) {
        var selected_bid = {};
        var bidNote = false;

        _.each(bids[0].bidding_trades, function(trade) {
            // trade.bid_list = taskTotalsService.mergeBidAndTaskList(
            //     plans, 
            //     tradeCodeService.getCode($scope.user.trade[0]), 
            //     trade.task_list, 
            //     trade.bid, 
            //     trade.costs);

            var bid_revs = [];
            _.each(trade.revisions, function(rev, idx) {
                bid_revs.push(idx+1);
            });

            bid_revs.push(bid_revs.length+1);

            trade.bid_list = taskTotalsService.mergeBidAndTaskList(
                plans, 
                tradeCodeService.getCode($scope.user.trade[0]), 
                trade,
                bid_revs);

            taskTotalsService.getCalculations(
                trade.bid_list, 
                trade.costs);

            selected_bid = trade;
        });

        // _.each(selected_bid.bid_list, function(bid) {
        //     bid.plan_code = bid.plan.item;
        // });

        var planData = [];

        //materials that are not combined can cause problems with the
        //report data by adding duplicate columns.  per_entry is used
        //to make sure we just adjust value totals instead of dup columns.
        var per_entry = false;

        //build data for each plan involved in the report
        _.each(plans, function(planReport) {
            var datas = $filter('filter')(selected_bid.bid_list, {'plan': planReport}, true);

            if($scope.report_options.selected_row === "General Tasks") {
                if($scope.report_options.selected_column === "Bid Labor Hours") {
                    var bid_labor_hours = 0;
                    _.each(datas, function(item) {
                        bid_labor_hours += item.total_hours_allowed;
                        planData.push({
                            'plan': planReport,
                            'name': item.trade + item.task + ' - ' + item.name,                                    
                            'task': item.trade + item.task,
                            'value': item.total_hours_allowed
                        });
                    });
                    planData.row_total = bid_labor_hours;
                } else if($scope.report_options.selected_column === "Bid Direct Labor Cost") {
                    var total_current_net_pay = 0;
                    _.each(datas, function(item) {
                        total_current_net_pay += item.total_current_net_pay;
                        planData.push({
                            'plan': planReport,
                            'name': item.trade + item.task + ' - ' + item.name,
                            'task': item.trade + item.task,
                            'value': item.total_current_net_pay
                        });
                    });
                    planData.row_total = total_current_net_pay;
                } else if($scope.report_options.selected_column === "Bid Total Material Cost") {
                    var total_materials = 0;
                    _.each(datas, function(item) {
                        total_materials += item.total_materials;
                        planData.push({
                            'plan': planReport,
                            'name': item.trade + item.task + ' - ' + item.name,
                            'task': item.trade + item.task,
                            'value': item.total_materials
                        });
                    });
                    planData.row_total = total_materials;
                } else if($scope.report_options.selected_column === "Bid Total Equipment Cost") {
                    var total_equipment = 0;
                    _.each(datas, function(item) {
                        total_equipment += item.total_equipment;
                        planData.push({
                            'plan': planReport,
                            'name': item.trade + item.task + ' - ' + item.name,
                            'task': item.trade + item.task,
                            'value': item.total_equipment
                        });
                    });
                    planData.row_total = total_equipment;
                }
            } else if($scope.report_options.selected_row === "Subtasks") {
                bidNote = true;
                if($scope.report_options.selected_column === "Bid Labor Hours") {
                    var bid_labor_hours = 0;
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            bid_labor_hours += data.hours_allowed;
                            planData.push({
                                'plan': planReport,
                                'name': data.trade + data.task + ' - ' + data.name,
                                'note': data.note,
                                'task': data.trade + data.task,
                                'value': data.hours_allowed
                            });
                        });
                    });
                    planData.row_total = bid_labor_hours;
                } else if($scope.report_options.selected_column === "Bid Direct Labor Cost") {
                    var total_labor = 0;
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            total_labor += data.current_net_pay;
                            planData.push({
                                'plan': planReport,
                                'name': data.trade + data.task + ' - ' + data.name,
                                'note': data.note,
                                'task': data.trade + data.task,
                                'value': data.current_net_pay
                            });
                        });
                    });
                    planData.row_total = total_labor;
                } else if($scope.report_options.selected_column === "Bid Total Material Cost") {
                    var material_total = 0;
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            material_total += data.material_total;
                            planData.push({
                                'plan': planReport,
                                'name': data.trade + data.task + ' - ' + data.name,
                                'note': data.note,
                                'task': data.trade + data.task,
                                'value': data.material_total
                            });
                        });
                    });
                    planData.row_total = material_total;
                } else if($scope.report_options.selected_column === "Bid Total Equipment Cost") {
                    var equipment_total = 0;
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            equipment_total += data.equipment_total;
                            planData.push({
                                'plan': planReport,
                                'name': data.trade + data.task + ' - ' + data.name,
                                'note': data.note,
                                'task': data.trade + data.task,
                                'value': data.equipment_total
                            });
                        });
                    });
                    planData.row_total = equipment_total;
                }
            } else if($scope.report_options.selected_row === "Materials") {
                bidNote = true;
                if($scope.report_options.selected_column === "Bid Quantity (combined)") {
                    var quantity_total = 0;
                    var materials = [];
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.materials, function(material) {
                                material.bid_quantity = (material.quantity)?material.quantity:material.quantity_allowed;
                                if(isNaN(material.bid_quantity)) {
                                    material.bid_quantity = 0;
                                }
                                material.note = (material.note)?material.note:'';
                                materials.push(material)
                            })
                        });
                    });

                    var new_consolidated_list = 
                        foremanPhaseService.combineSimilarNoteItems(materials);
                    //materials = foremanPhaseService.combineSimilarItems(materials);
                    _.each(new_consolidated_list, function(data) {
                        quantity_total += data.bid_quantity;

                        planData.push({
                            'plan': planReport,
                            'name': data.name,
                            'note': data.note,
                            'color_code': data.color_code,
                            'value': data.bid_quantity
                        });
                    });
                    planData.row_total = quantity_total;
                } else if($scope.report_options.selected_column === "Bid Quantity (per entry)") {
                    per_entry = true;
                    var quantity_total = 0;
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.materials, function(material) {
                                material.bid_quantity = (material.quantity)?material.quantity:material.quantity_allowed;
                                if(isNaN(material.bid_quantity)) {
                                    material.bid_quantity = 0;
                                }
                                quantity_total += material.bid_quantity;
                                material.note = (material.note)?material.note:'';

                                planData.push({
                                    'plan': planReport,
                                    'name': material.name,
                                    'note': material.note,
                                    'color_code': material.color_code,
                                    'value': material.bid_quantity
                                });
                            })
                        });
                    });
                    planData.row_total = quantity_total;
                } else if($scope.report_options.selected_column === "Bid Cost (combined)") {
                    var total = 0;
                    var materials = [];
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.materials, function(material) {
                                material.bid_quantity = (material.quantity)?material.quantity:material.quantity_allowed;
                                if(isNaN(material.bid_quantity)) {
                                    material.bid_quantity = 0;
                                }
                                material.note = (material.note)?material.note:'';
                                materials.push(material)
                            })
                        });
                    });
                    var new_consolidated_list = 
                        foremanPhaseService.combineSimilarNoteItems(materials);
                    
                    var tax = 0;
                    if($scope.project_side) {
                        tax = $scope.selectedItem.trades[0].company_factors.equipment_tax;
                    } else {
                        tax = $scope.my_bid.costs.sales_tax;
                    }
                    
                    _.each(new_consolidated_list, function(data) {
                        var subtotal = data.bid_quantity * data.price_per_order;
                        var sales_tax = subtotal * tax;
                        var dev_subtotal = data.delivery_price * data.bid_quantity;
                        data.total = subtotal + sales_tax + dev_subtotal;

                        total += data.total;

                        planData.push({
                            'plan': planReport,
                            'name': data.name,
                            'note': data.note,
                            'color_code': data.color_code,
                            'value': data.total
                        });
                    });
                    planData.row_total = total;
                } else if($scope.report_options.selected_column === "Bid Cost (per entry)") {
                    per_entry = true;
                    var mat_total = 0;
                    var tax = 0;
                    if($scope.project_side) {
                        tax = $scope.selectedItem.trades[0].company_factors.sales_tax;
                    } else {
                        tax = $scope.my_bid.costs.equipment_tax;
                    }
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.materials, function(material) {
                                material.bid_quantity = (material.quantity)?material.quantity:material.quantity_allowed;
                                if(isNaN(material.bid_quantity)) {
                                    material.bid_quantity = 0;
                                }

                                var subtotal = material.bid_quantity * material.price_per_order;
                                var sales_tax = subtotal * tax;
                                var dev_subtotal = material.delivery_price * material.bid_quantity;
                                material.total = subtotal + sales_tax + dev_subtotal;

                                material.note = (material.note)?material.note:'';

                                planData.push({
                                    'plan': planReport,
                                    'name': material.name,
                                    'note': material.note,
                                    'color_code': material.color_code,
                                    'value': material.total
                                });
                            })
                        });
                    });
                    planData.row_total = mat_total;
                }
            } else if($scope.report_options.selected_row === "Equipment") {
                bidNote = true;
                if($scope.report_options.selected_column === "Bid Quantity (combined)") {
                    var quantity_total = 0;
                    var equipment = [];
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.equipment, function(item) {
                                item.bid_quantity = (item.quantity)?item.quantity:item.quantity_allowed;
                                if(isNaN(item.bid_quantity)) {
                                    item.bid_quantity = 0;
                                }
                                item.note = (item.note)?item.note:'';
                                equipment.push(item)
                            })
                        });
                    });

                    equipment = foremanPhaseService.combineSimilarItems(equipment);

                    var consolidated_list = [];

                    if($scope.project_side) {
                        consolidated_list = foremanPhaseService.consolidateEquipmentOnForemanNotes(
                            equipment, $scope.selectedItem.trades[0].company_factors.equipment_tax);
                    } else {
                        consolidated_list = foremanPhaseService.consolidateEquipmentOnForemanNotes(
                            equipment, $scope.my_bid.costs.equipment_tax);
                    }

                    //materials = foremanPhaseService.combineSimilarItems(materials);
                    _.each(consolidated_list, function(data) {
                        quantity_total += data.bid_quantity;

                        planData.push({
                            'plan': planReport,
                            'name': data.name,
                            'note': data.note,
                            'value': data.bid_quantity
                        });
                    });
                    planData.row_total = quantity_total;
                } else if($scope.report_options.selected_column === "Bid Quantity (per entry)") {
                    per_entry = true;
                    var quantity_total = 0;
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.equipment, function(equip) {
                                quantity_total += (equip.quantity)?equip.quantity:equip.quantity_allowed;
                                if(isNaN(quantity_total)) {
                                    quantity_total = 0;
                                }
                                equip.note = (equip.note)?equip.note:'';

                                planData.push({
                                    'plan': planReport,
                                    'name': equip.name,
                                    'note': equip.note,
                                    'value': quantity_total
                                });
                            })
                        });
                    });
                    planData.row_total = quantity_total;
                } else if($scope.report_options.selected_column === "Bid Cost (combined)") {
                    var total = 0;
                    var equipment = [];
                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.equipment, function(equip) {
                                equip.bid_quantity = (equip.quantity)?equip.quantity:equip.quantity_allowed;
                                if(isNaN(equip.bid_quantity)) {
                                    equip.bid_quantity = 0;
                                }
                                equip.note = (equip.note)?equip.note:'';
                                equipment.push(equip)
                            })
                        });
                    });
                    var new_consolidated_list = 
                        foremanPhaseService.combineSimilarNoteItems(equipment);
                    var tax = 0;
                    if($scope.project_side) {
                        tax = $scope.selectedItem.trades[0].company_factors.equipment_tax;
                    } else {
                        tax = $scope.my_bid.costs.equipment_tax;
                    }
                    
                    _.each(new_consolidated_list, function(data) {
                        var subtotal = data.bid_quantity * data.price_per_order;
                        var sales_tax = subtotal * tax;
                        var dev_subtotal = data.delivery_price * data.bid_quantity;
                        data.total = subtotal + sales_tax + dev_subtotal;

                        total += data.total;

                        planData.push({
                            'plan': planReport,
                            'name': data.name,
                            'note': data.note,
                            'value': data.total
                        });
                    });
                    planData.row_total = total;
                } else if($scope.report_options.selected_column === "Bid Cost (per entry)") {
                    per_entry = true;
                    var equip_total = 0;
                    var tax = 0;
                    if($scope.project_side) {
                        tax = $scope.selectedItem.trades[0].company_factors.equipment_tax;
                    } else {
                        tax = $scope.my_bid.costs.equipment_tax;
                    }

                    _.each(datas, function(item) {
                        _.each(item.subtasks, function(data) {
                            _.each(data.equipment, function(equip) {
                                var sales_tax = equip.equipment_subtotal * tax;
                                var subtotal = equip.quantity_allowed * equip.price_per_order;
                                var dev_subtotal = equip.quantity_allowed * equip.delivery_price;
                                equip.total = subtotal + sales_tax + dev_subtotal;
                                equip_total += equip.total;
                                equip.note = (equip.note)?equip.note:'';

                                planData.push({
                                    'plan': planReport,
                                    'name': equip.name,
                                    'note': equip.note,
                                    'value': equip.total
                                });
                            })
                        });
                    });
                    planData.row_total = equip_total;
                }
            }
        });

        var report = {
            'row_type': $scope.report_options.selected_row,
            'column_type': $scope.report_options.selected_column,
            'rows': []
        }

        var column_total = 0;
        var first = true;
        //build data table based on lots being used
        _.each(plans, function(plan) {
            var itemDatas = $filter('filter')(planData, {'plan': plan}, true);
            
            if(per_entry) {
                if(!report.rows.columns) report.rows.columns = [];

                _.each(itemDatas, function(data, idx) {
                    if(!report.rows.columns) report.rows.columns = [];

                    if(first) {
                        report.rows.push({
                            name: data.name,
                            note: data.note,
                            columns: [{
                                'plan': plan,
                                'value': data.value
                            }]
                        })
                    } else {
                        report.rows[idx].columns.push({
                            'plan': plan,
                            'value': data.value
                        })
                    }

                    column_total += data.value;
                    if(idx === itemDatas.length-1) {
                        var col_total = $filter('filter')(report.rows, {'name': 'Totals'}, true);

                        if(col_total.length === 0) {
                            report.rows.push({
                                'name': 'Totals',
                                'columns': [{
                                    'value': column_total
                                }]
                            });
                        } else if(col_total.length === 1) {
                            col_total[0].columns.push({
                                'value': column_total
                            })
                        }

                        column_total = 0;
                    }
                });

                first = false;
            } else {
                _.each(itemDatas, function(data, idx) {
                    var inlist = [];
                    if(bidNote) {
                        inlist = $filter('filter')(report.rows, {
                            'name': data.name, 'note': data.note}, true);
                    } else {
                        inlist = $filter('filter')(report.rows, {'name': data.name}, true);
                    }

                    if(inlist.length === 0) {
                        if(!report.rows.columns) report.rows.columns = [];

                        report.rows.push({
                            name: data.name,
                            note: data.note,
                            columns: [{
                                'plan': plan,
                                'value': data.value
                            }]
                        })
                    } else if(inlist.length === 1) {
                        inlist[0].columns.push({
                            'plan': plan,
                            'value': data.value
                        })
                    } else {
                        toaster.pop('Report Error', 'Something is wrong');
                        return;
                    }

                    column_total += data.value;
                    if(idx === itemDatas.length-1) {
                        var col_total = $filter('filter')(report.rows, {'name': 'Totals'}, true);

                        if(col_total.length === 0) {
                            report.rows.push({
                                'name': 'Totals',
                                'columns': [{
                                    'value': column_total
                                }]
                            });
                        } else if(col_total.length === 1) {
                            col_total[0].columns.push({
                                'value': column_total
                            })
                        }

                        column_total = 0;
                    }
                })
            }
        });

        console.log(report);
        $scope.exportReportFile(report, bidNote);
        //$scope.exportReportFile(planData, bidNote);
    };

    $scope.runReportOperation = function (project) {
        console.log('running the report')
        $scope.ordered_lots = $scope.$parent.ordered_lots;
        $scope.selectedItem = $scope.$parent.selectedItem;
        $scope.plans = $scope.$parent.plans;
        $scope.project_side = project;

        if($scope.project_side) {
            var phases = [];
            var ordered_lots = [];
            _.each($scope.ordered_lots, function(lot) {
                if(phases.indexOf(lot.phase) === -1) {
                    phases.push(lot.phase);
                }
                ordered_lots.push(lot.number);
            });

            phases.unshift('All');
            ordered_lots.unshift('All');

            $scope.report_options = {
                'phases': phases,
                'lots': ordered_lots,
                'selected_phase': [phases[0]],
                'selected_lot': [ordered_lots[0]],
                'project_id': $scope.selectedItem._id,
                'rows': ['General Tasks', 'Subtasks', 'Materials', 'Equipment'],
                'task_coloumns': ['Bid Labor Hours', 'Bid Direct Labor Cost', 'Bid Total Material Cost', 'Bid Total Equipment Cost'],
                'material_columns': ['Bid Quantity (combined)', 'Bid Quantity (per entry)', 'Bid Cost (combined)', 'Bid Cost (per entry)']
            };
        } else {
            var plans = [];

            _.each($scope.plans, function(plan) {
                plans.push(plan.item);
            });

            plans.unshift('All');

            $scope.report_options = {
                'plans': plans,
                'selected_plan': [plans[0]],
                'rows': ['General Tasks', 'Subtasks', 'Materials', 'Equipment'],
                'task_coloumns': ['Bid Labor Hours', 'Bid Direct Labor Cost', 'Bid Total Material Cost', 'Bid Total Equipment Cost'],
                'material_columns': ['Bid Quantity (combined)', 'Bid Quantity (per entry)', 'Bid Cost (combined)', 'Bid Cost (per entry)']
            };
        }

        ngDialog.openConfirm({
            template: 'projects/views/project/report.html',
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            if($scope.project_side) {
                Bids.query({'project_id': $scope.report_options.project_id}, function(bids) {
                    if(bids.length != 1) {
                        if($scope.trade_options) {
                            Bids.query({'_id': $scope.trade_options.bid_id}, function(bids) {
                                if(bids.length != 1) {
                                    toaster.pop('Bid Error', 'Could not find bid');
                                } else if(bids[0].bidding_trades.length !== 1) {
                                    toaster.pop('Bid Error', 'Too many bid trades');
                                } else {
                                    $scope.buildReportData(bids);
                                }
                            });
                        } else {
                            toaster.pop('Bid Error', 'Could not find bid or associated options');
                        }
                    } else if(bids[0].bidding_trades.length !== 1) {
                        toaster.pop('Bid Error', 'Too many bid trades');
                    } else {
                        $scope.buildReportData(bids);
                    }
                });
            } else {
                Bids.query({'_id': $scope.$parent.bid._id}, function(bids) {
                    $scope.selectedBid = bids[0];
                    if(bids.length != 1) {
                        toaster.pop('Bid Error', 'Could not find bid');
                    } else if(bids[0].bidding_trades.length !== 1) {
                        toaster.pop('Bid Error', 'Too many bid trades');
                    } else {
                        if($scope.report_options.selected_plan[0] === 'All') {
                            var plans = [];

                            _.each($scope.plans, function(plan) {
                                plans.push(plan.item);
                            });

                            $scope.buildBidReportData(bids, plans);
                        } else
                            $scope.buildBidReportData(bids, $scope.report_options.selected_plan);
                    }
                });
            }
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };
  }
]);




// WEBPACK FOOTER //
// ./packages/custom/projects/public/controllers/report.js